import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../../common/page-title';
import PipEposObjectivesSearch from './pip-epos-objectives-search';
import PipEposObjectivesTable from './pip-epos-objectives-table';
import { downloadPipEposObjectives, getPipEposObjectives } from '../../../../actions/pip-epos-objectives';

class PipEposObjectivesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      objectiveName: '',
      startDateFrom: '',
      endDateTo: ''
    };
  }

  componentDidMount() {
    this.handleSearch();
  }

  handleObjectiveNameChange = (event) => {
    this.setState({ objectiveName: event.target.value });
  };

  handleStartDateFrom = (value) => {
    if (typeof value === 'object') {
      this.setState({ startDateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ startDateFrom: '' });
    }
  };

  handleEndDateTo = (value) => {
    if (typeof value === 'object') {
      this.setState({ endDateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ endDateTo: '' });
    }
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      objectiveName,
      startDateFrom,
      endDateTo
    } = this.state;

    dispatch(getPipEposObjectives(objectiveName, startDateFrom, endDateTo));
  };

  handleClear = () => {
    this.setState({
      objectiveName: '',
      startDateFrom: '',
      endDateTo: ''
    }, this.handleSearch);
  };

  handleDownload = () => {
    const { dispatch } = this.props;
    const {
      objectiveName,
      startDateFrom,
      endDateTo
    } = this.state;

    dispatch(downloadPipEposObjectives(objectiveName, startDateFrom, endDateTo));
  };

  render() {
    const {
      objectiveName,
      startDateFrom,
      endDateTo
    } = this.state;

    return (
      <div>
        <PageTitle>
          Epos Objectives
        </PageTitle>
        <PipEposObjectivesSearch
          objectiveName={objectiveName}
          startDateFrom={startDateFrom}
          endDateTo={endDateTo}
          onHandleObjectiveNameChange={this.handleObjectiveNameChange}
          onHandleStartDateFromChange={this.handleStartDateFrom}
          onHandleEndDateToChange={this.handleEndDateTo}
          onHandleSearch={this.handleSearch}
          onHandleClear={this.handleClear}
          onHandleDownload={this.handleDownload}
        />
        <PipEposObjectivesTable />
      </div>
    );
  }
}

export default connect(null)(PipEposObjectivesPage);
